import React from 'react'
import classNames from 'classnames'

import { DATABASE_TYPE_OPTIONS } from '../../../utils/databases'

import Card from '../../Shared/Card'
import Button from '../../Shared/Button'
import TestData from './TestData'

import styles from './InitialSetup.module.css'

export default function DatabaseType({ onSubmit, type, setType }) {
  return (
    <>
      <Card
        actions={
          <Button onClick={onSubmit} disabled={!type}>
            Setup Datasource
          </Button>
        }
      >
        <h1>Let’s connect a datasource</h1>
        <p className="subtitle">
          Setup your first source so you can get started creating views &
          actions.
        </p>
        <h5 className={styles.label}>Choose a Source</h5>
        <div className={styles.types}>
          {DATABASE_TYPE_OPTIONS.map(opt => (
            <div
              onClick={() => setType(opt.value)}
              className={classNames(
                styles.type,
                type === opt.value && styles.selected,
                opt.disabled && styles.disabled
              )}
            >
              <div className={styles.imageWrapper}>
                <img src={opt.image} alt={opt.label} />
              </div>
              <p className={styles.optionLabel}>
                {opt.label}
                {opt.disabled && (
                  <span className={styles.comingSoon}>Coming Soon</span>
                )}
              </p>
            </div>
          ))}
        </div>
      </Card>
      <TestData />
    </>
  )
}
